export default {
  path: 'vehicles/:id',
  name: 'FleetVehicleView',
  component: () => import(/* webpackChunkName: "fleet" */ '../views/FleetVehicleView.vue')
}
